<div class="p-3">
  <div class="modal-header">
    <p class="modal-title">
      <strong>{{ isEdit ? "Update Document Type" : "Create Document Type" }}</strong>
    </p>
    <button type="button" (click)="modal.dismiss()" class="btn-close" aria-label="Close"></button>
  </div>

  <div class="modal-body p-3">
    <form [formGroup]="createForm">
      <div class="row m-0 pt-2">
            <div class="col-8">
                <label>Document Type Name</label>
                <input
                    type="text"
                    class="form-control"
                    formControlName="documentTypeName"
                    placeholder="Enter document type name" />
                <small class="text-danger mt-1 d-block" *ngIf="isDuplicate">
                    Document type name already exists.
                </small>
            </div>
      </div>
      <div class="row m-0 pt-2" *ngIf="isEdit">
      <div class="col-8 d-flex align-items-center gap-2">
        <input type="checkbox" formControlName="isActive" id="isActiveCheck" />
        <label for="isActiveCheck" class="mb-0">Active</label>
      </div>
    </div>
    </form>
  </div>

  <div class="modal-footer">
    <button class="btn btn-outline-primary" (click)="modal.dismiss()">Cancel</button>
    <button
      class="btn btn-secondary"
      [disabled]="createForm.invalid || isDuplicate || (isEdit && !hasChanges)"
      eosDebounce
      (debounceClick)="save()">
      {{ isEdit ? "Update" : "Create" }}
    </button>
  </div>
</div>